import React from 'react'

const ImageElement = (props) => {


    return (<div>Image</div>)
}

export default ImageElement;